const orientacoes_penalidades = {
	items: [
		{
			titulo: 'Cartas de orientação',
			descricao: `
                Enviamos orientações educativas para as instituições em relação a desvios de cumprimento das regras dos códigos. Cada carta pode falar de um ou mais tópicos.
			`
		},
		{
			titulo: 'Cartas de recomendação',
			descricao: `
                Quando a investigação do PAI encontra uma infração que tem pequeno potencial de dano para o mercado e é simples de reparar, podemos enviar uma carta de recomendação. Esse comunicado traz instruções sobre como a instituição pode corrigir sua conduta, de acordo com as regras do código. Ao adotar as medidas propostas, a empresa não fica mais sujeita à punição. Essas cartas ficam públicas no nosso portal - 
                <a href="https://www.anbima.com.br/pt_br/autorregular/supervisao/orientacoes-e-penalidades.htm" target="_blank" class="text_link text_link--yellow text_link--no-underline">confira aqui</a>
			`
		},
		{
			titulo: 'Julgamentos',
			descricao: `
                Resultado de processos, também são feitos pelos conselhos de cada código, que julgam os descumprimentos mais graves das regras. Podem resultar em termos de compromisso ou em penalidades distintas, como multas, perda do direito de uso do selo de autorregulação ou, até mesmo, exclusão do código.
			`
		},
		{
			titulo: 'Multas',
			descricao: `
                Penalidade financeira aplicada quando há descumprimentos objetivos relacionados aos códigos – por exemplo, atraso no envio de informações para as bases de dados, aplicação incorreta do suitability, entre outros.
			`
		},
		{
			titulo: 'PAIs (Procedimento para Apuração de Irregularidades)',
			descricao: `
                É uma investigação para analisar os indícios de descumprimento às regras dos códigos.
			`
		},
		{
			titulo: 'Pedidos de esclarecimento',
			descricao: `
                Solicitamos que a instituição envie mais informações sobre algum tema – como dados prestados à supervisão ou atividade.
			`
		},
		{
			titulo: 'Processos',
			descricao: `
                Quando constatamos o descumprimento às regras do código, <a href="#/iniciativa/balanco-das-orientacoes-e-penalidades-da-autorregulacao" class="text_link text_link--yellow text_link--no-underline">os conselhos de cada código</a> instauram um processo. Dependendo do nível de gravidade, ele pode resultar em um julgamento.
			`
		},
		{
			titulo: 'Termos de compromisso',
			descricao: `
                Durante um PAI, processo ou até o julgamento, as instituições podem propor um termo de compromisso para corrigir possíveis descumprimentos às regras. Ele não é uma confissão de erro, mas suspende as ações que estavam em andamento até que a instituição faça o que prometeu – como correção de determinada atividade ou pagamento de um recurso financeiro.
			`
		}
	]
};

export { orientacoes_penalidades };
